module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_ASD.87b3b02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_ASD.png
// module id = 43
// module chunks = 0